import { usePriceSection } from "./usePriceSection";
export const usePriceLayout = () => { var _a; return (_a = usePriceSection()) === null || _a === void 0 ? void 0 : _a.layout; };
